import { Form, Input, Modal } from 'antd';
import React, { useState } from 'react';
import { toast } from 'sonner';
const ExtensionDetailsModal = ({
  open,
  onCloseModal
}) => {
  const [extendTrialLoading, setExtendTrialLoading] = useState(false);
  const [extendTrailDomainInterest, setExtendTrailDomainInterest] = useState('');
  const [extendTrailCompanyName, setExtendTrailCompanyName] = useState('');
  const [extendTrailPlatformFeedback, setExtendTrailPlatformFeedback] = useState('');
  const {
//     VITE_APP_URL: APP_URL
  } = import.meta.env;
  const extendTrial = async () => {
    try {
      setExtendTrialLoading(true);
      toast.success("Your Extension request submitted successfully");
    } catch (error) {
      if (error.response?.status === 400) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Something went wrong");
      }
    } finally {
      setExtendTrialLoading(false);
      onCloseModal();
      // setExtendDaysSubmitted(true)
    }
  };
  return <Modal open={open} onCancel={onCloseModal} title="Trial Extension Request" centered width={1024} onOk={extendTrial} confirmLoading={extendTrialLoading} okText="Submit">
                    <Form layout='vertical' className='mt-8' size='large'>
                        <div className='flex flex-col gap-y-4 mt-4'>
                            <Form.Item label={<span className='font-bold'>Which domain you are interested in?</span>} className='mt-4' rules={[{
          required: true,
          message: 'Please enter domain interest'
        }]}>
                                <Input placeholder="Enter domain interest" value={extendTrailDomainInterest} onChange={e => setExtendTrailDomainInterest(e.target.value)} />
                            </Form.Item>
                            <Form.Item label={<span className='font-bold'>What is your company name?</span>} className='mt-4' rules={[{
          required: true,
          message: 'Please enter your company name'
        }]}>
                                <Input placeholder="Enter company name" value={extendTrailCompanyName} onChange={e => setExtendTrailCompanyName(e.target.value)} />
                            </Form.Item>
                            <Form.Item label={<span className='font-bold'>Platform Feedback:</span>} className='mt-4' rules={[{
          required: true,
          message: 'Please enter platform feedback'
        }]}>
                                <Input.TextArea rows={4} placeholder="Enter platform feedback" value={extendTrailPlatformFeedback} onChange={e => setExtendTrailPlatformFeedback(e.target.value)} />
                            </Form.Item>
                        </div>
                        
                    </Form>
                </Modal>;
};
export default ExtensionDetailsModal;